import PropTypes from 'prop-types';
import React from 'react';

import PropertiesTable from '~/features/base/components/table/PropertiesTable';

const tableClassName = 'table table-condensed table-hover';

export const VehiclePropertiesTable = ({ vehicleInfo, rowDescriptors }) => {
    return <PropertiesTable showHeader={false} className={tableClassName} data={vehicleInfo}
                            rowDescriptors={rowDescriptors}/>;
};

export default VehiclePropertiesTable;

VehiclePropertiesTable.defaultProps = {
    vehicleInfo: undefined,
    rowDescriptors: [],
};

VehiclePropertiesTable.propTypes = {
    // props
    vehicleInfo: PropTypes.object,
    rowDescriptors: PropTypes.array,
};
